import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './badge-collection.styl'
import { get } from 'lodash'
import { getBadgeIconImgByNames } from '../../../helpers/badgeHelper'

class BadgeCollection extends Component {
  static propTypes = {
    awardBadges: PropTypes.object.isRequired,
    activitySection: PropTypes.object,
    awardLevel: PropTypes.object
  }


  render() {
    const { awardBadges, activitySection, awardLevel } = this.props

    const badgesForSection = awardBadges.filter(ab => get(ab, 'activitySection.value') === activitySection && get(awardLevel, 'value') === get(ab, 'award.awardLevel.value'))

    return (
      <div className={styles.badgeCollectionWrapper}>

        { badgesForSection && badgesForSection.map(data => {
          const badgeIconImg = getBadgeIconImgByNames(awardLevel, get(data, 'badge'), true)

          return(
            <div className={styles.badgeWrapper}>
              <div className={`${styles.badgeIcon}`}>
                <img className={`${styles.badgeImgSmall}`} src={`data:image/png;base64, ${badgeIconImg}`} />
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default BadgeCollection
